import { type ColumnType } from 'antd/lib/table/interface';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

import store from 'stores/RootStore';
import type User from 'stores/User';
import { formatDateTimeMedSeconds } from 'utils/Dates';

import SiteRoleSelect from '../../UI/SiteRoleSelect';
import { searchFilterFields } from '../../UI/Table/Column';
import Table from '../../UI/Table/Table';
import UserActivationSwitch from '../../UI/UserActivationSwitch/UserActivationSwitch';
import ViewsLayout from '../../UI/ViewsLayout/ViewsLayout';
import {
  makeBooleanSorter,
  makeStringFilter,
  makeStringSorter,
  makeTimestampSorter,
  makeUserRoleSorter
} from 'utils/TableUtils';

const ADMIN_VIEW_TITLE = 'Admin';
const ADMIN_TABLE_TITLE = 'All Users';

function getTableColumns(): Array<ColumnType<User>> {
  return [
    {
      title: 'Name',
      render: (_value, record) => record.data.displayName,
      sorter: makeStringSorter((r) => r.data.displayName),
      ...searchFilterFields,
      onFilter: makeStringFilter((r) => r.data.displayName)
    },

    {
      title: 'E-mail',
      render: (_value, record) => record.data.email,
      sorter: makeStringSorter((r) => r.data.email),
      ...searchFilterFields,
      onFilter: makeStringFilter((r) => r.data.email)
    },

    {
      title: 'Modified',
      render: (_value, record) =>
        formatDateTimeMedSeconds(record.data?.dateModified),
      sorter: makeTimestampSorter((r) => r.data.dateModified)
    },

    {
      title: 'Activated',
      render: (_value, record) => <UserActivationSwitch user={record} />,
      width: 50,
      sorter: makeBooleanSorter((r) => r.data.activated)
    },

    {
      title: 'Role',
      render: (_value, record) => <SiteRoleSelect store={record} />,
      width: 50,
      sorter: makeUserRoleSorter((r) => r.data.role)
    }
  ];
}

function Admin() {
  const data = [...store.admin.users.all];
  const isLoading = store.admin.users.loading;

  useEffect(() => {
    window.document.title = ADMIN_VIEW_TITLE;
  }, []);

  return (
    <ViewsLayout>
      <Table
        columnsDefinition={getTableColumns()}
        data={data}
        isLoading={isLoading}
        loadingLabel=""
        title={ADMIN_TABLE_TITLE}
      />
    </ViewsLayout>
  );
}

export default observer(Admin);
